/** @format */
import {useLocation, useNavigate, useParams} from 'react-router-dom';
import React from 'react';
import {RouterContext} from './router_context';

const withRouter = Component => {
    function ComponentWithRouterProp(props) {
        let location = useLocation();
        let navigate = useNavigate();
        let params = useParams();
        return (
            <RouterContext.Provider value={{location, navigate, params}}>
                <Component {...props} {...{location, navigate}} match={{params}} />
            </RouterContext.Provider>
        );
    }

    return ComponentWithRouterProp;
};

export default withRouter;
